<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <p>普莱柯，LIMS，VUE制作H5</p>
    <router-link v-for="link in routerList" :key="link.name" :to="link.name" class="router-style">{{link.title}}</router-link>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data(){
    return{
      routerList:[
        { title:'普莱柯H5注册',name:'register' },
        { title:'普莱柯专场',name:'special' },
        { title:'普莱柯统计报告',name:'SalesIndex' },
        { title:'健康管理种猪报告',name:'breedingPig' },
        { title:'健康管理商品猪阶段报告',name:'commodityPigStage' },
        { title:'健康管理商品猪周期报告',name:'commodityPigCycle' },
        { title:'莱客云个人统计',name:'PersonalStatistics' },
      ]
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h1 {
  font-size: 16px;
  padding-bottom: 20px;
}
p {
  font-size: 14px;
}
.router-style {
  font-size: 14px;
      display: inherit;
    margin: 20px 0;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
